// 生产地址
// const PortUrl = 'https://www.liangxin.net.cn/liangxin_new/'
// const WebUrl = 'https://www.liangxin.net.cn/liangxin_new/'

// 测试地址
const PortUrl = 'http://39.102.73.127/liangxin_new/'
const WebUrl = 'http://liangxindev.yunleader.com/liangxin_new/' // 测试地址


const constApi = {
  // 七牛相关
  QiNiuHttp: 'http://apptest.liangxin.net.cn/', // 测试
  // QiNiuHttp: 'http://appprod.liangxin.net.cn/', // 生产
  /**
   * @login 用户登录
   * @PutPassWord  修改用户密码
   */
  UserLogin: {
    login: PortUrl + 'webadmin/webAdminUser/signIn',
    PutPassWord: PortUrl + 'webadmin/webAdminUser/updatePwd'
  },
  QiniuToken: {
    Storage: PortUrl + 'webadmin/qiniu/getToken'
  },
  publicImages: {
    publicImages: PortUrl + 'publicImages',
    find: PortUrl + 'webadmin/publicResource/find',
    update: PortUrl + 'webadmin/publicResource/coverImg'
  },
  // 轮播图管理
  Carousel: {
    insert: PortUrl + 'webadmin/carousel/insert',
    update: PortUrl + 'webadmin/carousel/update/',
    find: PortUrl + 'webadmin/carousel/find',
    findById: PortUrl + 'webadmin/carousel/findById',
    move: PortUrl + 'webadmin/carousel/move',
    deleteById: PortUrl + 'webadmin/carousel/deleteById',
    deleteAll: PortUrl + 'webadmin/carousel/deleteAll'
  },
  // 每日阅读
  reading: {
    draftsFind: PortUrl + 'webadmin/readEveryDay/findDrafts',
    releasingFind: PortUrl + 'webadmin/readEveryDay/findRelease',
    revokedFind: PortUrl + 'webadmin/readEveryDay/findShelf',
    findById: PortUrl + 'webadmin/readEveryDay/findById',
    insert: PortUrl + 'webadmin/readEveryDay/insert',
    update: PortUrl + 'webadmin/readEveryDay/update',
    updateType: PortUrl + 'webadmin/readEveryDay/updateType',
    deleteById: PortUrl + 'webadmin/readEveryDay/deleteById',
    deleteAll: PortUrl + 'webadmin/readEveryDay/deleteAll',
    changeStatus: PortUrl + 'webadmin/readEveryDay/changeStatus',
    shelfAll: PortUrl + 'webadmin/readEveryDay/shelfAll'
  },
  // 每日阅读 评论
  comments: {
    find: PortUrl + 'webadmin/comments/find',
    shelfAll: PortUrl + 'webadmin/comments/shelfAll',
    shelf: PortUrl + 'webadmin/comments/commentLowerShelf'
  },
  // 黄历管理
  calendar: {
    find: PortUrl + 'webadmin/almanac/find',
    findById: PortUrl + 'webadmin/almanac/findById',
    update: PortUrl + 'webadmin/almanac/update/'
  },
  // 卦象管理
  Gua: {
    noteFind: PortUrl + 'webadmin/note/find',
    noteFindById: PortUrl + 'webadmin/note/findById',
    find: PortUrl + 'webadmin/gua64/find',
    findById: PortUrl + 'webadmin/gua64/findById',
    update: PortUrl + 'webadmin/gua64/update/',
    share: PortUrl + 'webadmin/shareRecord/findByUnlockTime',
    pay: PortUrl + 'webadmin/payRecord/find'
  },
  // 相关文章
  article: {
    find: PortUrl + 'webadmin/article/find',
    findById: PortUrl + 'webadmin/article/findByArticleId',
    insert: PortUrl + 'webadmin/article/insert',
    update: PortUrl + 'webadmin/article/update/',
    deleteById: PortUrl + 'webadmin/article/deleteById',
    deleteAll: PortUrl + '/webadmin/article/deleteAll'
  },
  // 通知管理
  notice: {
    push: PortUrl + 'webadmin/push/pushList',
    find: PortUrl + 'webadmin/message/find',
    findById: PortUrl + 'webadmin/message/findById',
    insert: PortUrl + 'webadmin/message/insert',
    update: PortUrl + 'webadmin/message/update/',
    deleteById: PortUrl + 'webadmin/message/deleteById',
    deleteByIdList: PortUrl + 'webadmin/message/deleteByIdList'
  },
  // 用户反馈
  feedback: {
    find: PortUrl + 'webadmin/feedback/find',
    findById: PortUrl + 'webadmin/feedback/findById',
    deleteById: PortUrl + 'webadmin/feedback/deleteById',
    deleteAll: PortUrl + 'webadmin/feedback/deleteList',
    findReply: PortUrl + 'webadmin/replyFeedback/find', // 查询回复信息
    insertReply: PortUrl + 'webadmin/replyFeedback/insert' // 添加回复信息
  },
  // 版本信息
  versionsNo: {
    insert: PortUrl + 'webadmin/versionsNo/insert',
    update: PortUrl + 'webadmin/versionsNo/update/',
    find: PortUrl + 'webadmin/versionsNo/all',
    findById: PortUrl + 'webadmin/versionsNo/findById',
    deleteById: PortUrl + 'webadmin/versionsNo/deleteById',
    deleteAll: PortUrl + 'webadmin/versionsNo/deleteList'
  },
  // 图表统计
  statistics: {
    countGua: PortUrl + 'webadmin/appUser/countHexagramRecord',
    countSex: PortUrl + 'webadmin/appUser/countSex',
    countPhone: PortUrl + 'webadmin/appUser/countPhoneType',
    registerNum: PortUrl + 'webadmin/appUser/registerNum',
    loginNum: PortUrl + 'webadmin/loginRecord/loginNum'
  },
  // 用户信息
  userManage: {
    countUser: PortUrl + 'webadmin/appUser/countUser',
    countGua: PortUrl + 'webadmin/hexagramRecord/find',
    countHua: PortUrl + 'webadmin/comments/findByAppUserId',
    countSuo: PortUrl + 'webadmin/payRecord/getLock',
    addShare: PortUrl + 'webadmin/shareRecord/insertList',
    find: PortUrl + 'webadmin/appUser/find',
    updateIsBlack: PortUrl + 'webadmin/appUser/updateIsBlack',
    findById: PortUrl + 'webadmin/appUser/findById',
    deleteById: PortUrl + 'webadmin/appUser/deleteById',
  },

  agreementManagement: {
    findById: PortUrl + 'webadmin/agreementManagement/findById',
    update: PortUrl + 'webadmin/agreementManagement/update',
  },

  Baoliweishi: {
    writeToken: 'WIb9ytKiTmB80pP-KTC8Vow9L6dWge59',
    polyvUploadVideo: 'http://v.polyv.net/uc/services/rest?method=uploadfile',
    polyvGetPlaysafeToken: PortUrl + 'webadmin/file/polyvGetPlaysafeToken'
  },

  material: {
    insert: PortUrl + '/webadmin/material/insert',
  },

  courseManage: {
    camp: {
      groupList: PortUrl + 'webadmin/group/findAll',
      groupDelete: PortUrl + 'webadmin/group/deleteById',
      groupDetail: PortUrl + 'webadmin/group/findById',
      groupUpdateStatus: PortUrl + 'webadmin/group/updateStatus',
      groupUdate: PortUrl + 'webadmin/group/update',
      groupInsert: PortUrl + 'webadmin/group/insert',
      campList: PortUrl + 'webadmin/trainingCamp/findAll',
      campDetail: PortUrl + 'webadmin/trainingCamp/findById',
      campGroupList: PortUrl + 'webadmin/trainingCamp/findAllGroupList',
      campInsert: PortUrl + 'webadmin/trainingCamp/insert',
      campUpdate: PortUrl + 'webadmin/trainingCamp/update',
      campDelete: PortUrl + 'webadmin/trainingCamp/deleteById',
      campUpdateStatus: PortUrl + 'webadmin/trainingCamp/updateStatus',
      tuwenList: PortUrl + 'webadmin/trainingCamp/findAllImgAndTextList',
      shipinList: PortUrl + 'webadmin/trainingCamp/findAllVideoList',
      yinpinList: PortUrl + 'webadmin/trainingCamp/findAllAudioList',
      kaoshiList: PortUrl + 'webadmin/trainingCamp/findAllExaminationList',
      zuoyeList: PortUrl + 'webadmin/assignment/findAll',
      giftList: PortUrl + 'webadmin/trainingCamp/findAllGiftList',
      copyLink: WebUrl + 'mobile_web/index.html#/pages/period/index?trainingCampId=',
      refresh: PortUrl + 'webadmin/trainingCamp/refresh'
    },
    campPeriod: {
      insert: PortUrl + 'webadmin/campPeriod/insert',
      update: PortUrl + 'webadmin/campPeriod/update',
      findAll: PortUrl + 'webadmin/campPeriod/findAll',
      unshelve: PortUrl + 'webadmin/campPeriod/unshelve',
      deleteById: PortUrl + '/webadmin/campPeriod/deleteById',
      putaway: PortUrl + 'webadmin/campPeriod/putaway',
      findAllCertificateList: PortUrl + 'webadmin/campPeriod/findAllCertificateList',
      findById: PortUrl + 'webadmin/campPeriod/findById',
      countLearnPlan: PortUrl + 'webadmin/campPeriod/countLearnPlan',
      manualInsert: PortUrl + 'webadmin/order/manualInsert',
      refresh: PortUrl + 'webadmin/campPeriod/refresh'

    },
    statistics: {
      countNumAndApplys: PortUrl + 'webadmin/campPeriod/countNumAndApplys',
      showFourDatas: PortUrl + 'webadmin/sellStatistics/showFourDatas',
      showThreeDatas: PortUrl + 'webadmin/learnResultStatistics/showThreeDatas',
      showEchart: PortUrl + 'webadmin/sellStatistics/showEchart',
      findAllStudentDetails: PortUrl + 'webadmin/studentStatistics/findAllStudentDetails',
      findAllLearnResult: PortUrl + 'webadmin/learnResultStatistics/findAllLearnResult',
      studentScheduleFindAll: PortUrl + 'webadmin/studentStatistics/studentScheduleFindAll',
      studentScheduleDetails: PortUrl + 'webadmin/studentStatistics/studentScheduleDetails',
      studentScheduleExport: PortUrl + 'webadmin/studentStatistics/studentScheduleExport',
      export: PortUrl + 'webadmin/learnResultStatistics/export',
      statisticsExp: PortUrl + 'webadmin/studentStatistics/export',
    },
    pic: {
      findAll: PortUrl + 'webadmin/imageAndText/findAll',
      deleteById: PortUrl + 'webadmin/imageAndText/deleteById',
      findById: PortUrl + 'webadmin/imageAndText/findById',
      insert: PortUrl + 'webadmin/imageAndText/insert',
      update: PortUrl + 'webadmin/imageAndText/update',
    },
    catalog: {
      findAll: PortUrl + 'webadmin/template/findAll',
      deleteById: PortUrl + 'webadmin/template/deleteById',
      copyById: PortUrl + 'webadmin/template/copyById',
      insert: PortUrl + 'webadmin/template/insert',
      update: PortUrl + 'webadmin/template/update',
      catalogFindAll: PortUrl + 'webadmin/templateClassCatalog/findAll',
      catalogInsert: PortUrl + 'webadmin/templateClassCatalog/insert',
      catalogDeleteById: PortUrl + 'webadmin/templateClassCatalog/deleteById',
      catalogUpdateSeq: PortUrl + 'webadmin/templateClassCatalog/updateSeq',
      catalogUpdate: PortUrl + 'webadmin/templateClassCatalog/update',
      learnFindAll: PortUrl + 'webadmin/templateLearnPlan/findAll',
      learnInserts: PortUrl + 'webadmin/templateLearnPlan/inserts',
      learnUpdateSeq: PortUrl + 'webadmin/templateLearnPlan/updateSeq',
      learnDeleteById: PortUrl + 'webadmin/templateLearnPlan/deleteById',
      findByTemplateIdTree: PortUrl + 'webadmin/template/findByTemplateIdTree',
    },
    video: {
      findAll: PortUrl + 'webadmin/video/findAll',
      deleteById: PortUrl + 'webadmin/video/deleteById',
      findById: PortUrl + 'webadmin/video/findById',
      insert: PortUrl + 'webadmin/video/insert',
      update: PortUrl + 'webadmin/video/update',
    },
    audio: {
      findAll: PortUrl + 'webadmin/audio/findAll',
      deleteById: PortUrl + 'webadmin/audio/deleteById',
      findById: PortUrl + 'webadmin/audio/findById',
      insert: PortUrl + 'webadmin/audio/insert',
      update: PortUrl + 'webadmin/audio/update',
    },
    material: {
      findAll: PortUrl + 'webadmin/material/findAll',
      insert: PortUrl + 'webadmin/material/insert',
      update: PortUrl + 'webadmin/material/update',
      deleteAll: PortUrl + 'webadmin/material/deleteAll',
      moveAll: PortUrl + 'webadmin/material/moveAll',
      findById: PortUrl + 'webadmin/material/findById',
    },
    materialGroup: {
      findAll: PortUrl + 'webadmin/materialGroup/findAll',
      deleteById: PortUrl + 'webadmin/materialGroup/deleteById',
      update: PortUrl + 'webadmin/materialGroup/update',
      insert: PortUrl + 'webadmin/materialGroup/insert'
    },
    gift: {
      findAll: PortUrl + 'webadmin/gift/findAll',
      deleteById: PortUrl + 'webadmin/gift/deleteById',
      findById: PortUrl + 'webadmin/gift/findById',
      insert: PortUrl + 'webadmin/gift/insert',
      update: PortUrl + 'webadmin/gift/update',
    },
    order: {
      findAll: PortUrl + 'webadmin/order/findAll',
      updateStatus: PortUrl + 'webadmin/order/updateStatus',
      updateLogisticsStatusAll: PortUrl + 'webadmin/order/updateLogisticsStatusAll',
      export: PortUrl + 'webadmin/order/export',
      exportGift: PortUrl + 'webadmin/order/exportGift',
    },
    certificate: {
      findAll: PortUrl + 'webadmin/certificate/findAll',
      deleteById: PortUrl + 'webadmin/certificate/deleteById',
      insert: PortUrl + 'webadmin/certificate/insert',
      update: PortUrl + 'webadmin/certificate/update',
      findById: PortUrl + 'webadmin/certificate/findById',
    },
    appointment: {
      findAll: PortUrl + 'webadmin/appointment/findAll',
      export: PortUrl + 'webadmin/appointment/export'
    },
    ticket: {
      findAll: PortUrl + 'webadmin/coupon/findAll',
      countGetStatus: PortUrl + 'webadmin/coupon/countGetStatus',
      updateStatus: PortUrl + 'webadmin/coupon/updateStatus',
      copyLink: WebUrl + 'mobile_web/index.html#/pages/ticket/index?id=',
      getCouponStatistics: PortUrl + 'webadmin/coupon/getCouponStatistics',
      refresh: PortUrl + 'webadmin/coupon/refresh',
      findAllCouponCampPeriods: PortUrl + 'webadmin/coupon/findAllCouponCampPeriods',
      findAllCouponUser: PortUrl + 'webadmin/coupon/findAllCouponUser',
      export: PortUrl + 'webadmin/coupon/export',
      deleteById: PortUrl + 'webadmin/coupon/deleteById',
      findById: PortUrl + 'webadmin/coupon/findById',
      insert: PortUrl + 'webadmin/coupon/insert',
      update: PortUrl + 'webadmin/coupon/update',
      findAllCampPeriod: PortUrl + 'webadmin/coupon/findAllCampPeriod',
      send: PortUrl + '/webadmin/member/sendMember',
      copyById: PortUrl + 'webadmin/template/copyById',
      undoCard: PortUrl + '/webadmin/member/undoCard',
    },
    questiongroup: {
      find: PortUrl + 'webadmin/examinationGroup/findAll',
      insert: PortUrl + 'webadmin/examinationGroup/insert',
      update: PortUrl + 'webadmin/examinationGroup/update',
      delete: PortUrl + '/webadmin/examinationGroup/deleteById'
    },
    question: {
      find: PortUrl + 'webadmin/question/findAll',
      findById: PortUrl + 'webadmin/question/findById',
      insert: PortUrl + 'webadmin/question/insert',
      update: PortUrl + 'webadmin/question/update',
      delete: PortUrl + 'webadmin/question/deleteByIds',
      move: PortUrl + 'webadmin/question/moveByIds'
    },
    examination: {
      findGroup: PortUrl + 'webadmin/examination/findGroup',
      find: PortUrl + 'webadmin/examination/findAll',
      findById: PortUrl + 'webadmin/examination/findById',
      insert: PortUrl + 'webadmin/examination/insert',
      update: PortUrl + 'webadmin/examination/update',
      delete: PortUrl + 'webadmin/examination/deleteById',
      move: PortUrl + 'webadmin/examination/moveByIds'
    },
    homework: {
      findAll: PortUrl + 'webadmin/assignment/findAll',
      deleteById: PortUrl + 'webadmin/assignment/deleteById',
      insert: PortUrl + 'webadmin/assignment/insert',
      update: PortUrl + 'webadmin/assignment/update',
      findById: PortUrl + 'webadmin/assignment/findById'
    },
    homeworkUser: {
      totalNumber: PortUrl + 'webadmin/assignmentUser/totalNumber',
      findAll: PortUrl + 'webadmin/assignmentUser/findAll',
      updateByTop: PortUrl + 'webadmin/assignmentUser/updateByTop',
      deleteById: PortUrl + 'webadmin/assignmentUser/deleteById',
      findById: PortUrl + 'webadmin/assignmentUser/findById',
      export: PortUrl + 'webadmin/assignmentUser/export'
    },
    member: {
      findAll: PortUrl + 'webadmin/member/findAll',
      deleteById: PortUrl + 'webadmin/member/deleteById',
      insert: PortUrl + 'webadmin/member/insert',
      update: PortUrl + 'webadmin/member/update',
      findById: PortUrl + 'webadmin/member/findById',
      copyLink: WebUrl + 'mobile_web/index.html#/pages/index/index',
      findMember: PortUrl + '/webadmin/userMemberRecord/findAll',
      exportMember: PortUrl + '/webadmin/userMemberRecord/export',
      importData: PortUrl + '/webadmin/member/importData',
      newMemberFindAll: PortUrl + '/webadmin/newMember/findById',
      newMemberUpdate: PortUrl + '/webadmin/newMember/update',

    },
    hide: {
      find: PortUrl + '/webadmin/hide/find',
      update: PortUrl + '/webadmin/hide/update'
    }
  }
}

export default {
  constApi: constApi
}



//////////////////
// WEBPACK FOOTER
// ./static/interface/data.js
// module id = null
// module chunks = 